import { useEffect, useRef } from 'react';
import { useData } from '../context/DataContext';
import { setConnectedAccountsProperty } from '@shared/services/analyticsTracker';

/**
 * Keeps the has_connected_accounts analytics user property in sync with
 * account state. Lives here (not in identifyUser's callers) because auth and
 * subscription don't observe accounts — this reads the live accounts data and
 * reports on every change, including disconnect-to-zero.
 */
export const useConnectedAccountsProperty = () => {
  const { plaidAssets, unifiedLiabilities } = useData();
  const hasConnectedAccounts = plaidAssets.length > 0 || unifiedLiabilities.length > 0;
  const lastReported = useRef<boolean | null>(null);

  useEffect(() => {
    if (lastReported.current === hasConnectedAccounts) return;
    lastReported.current = hasConnectedAccounts;
    setConnectedAccountsProperty(hasConnectedAccounts);
  }, [hasConnectedAccounts]);
};
